import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { VwsInformacionGeneralEntidadDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class VwsInformacionGeneralEntidadService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getVwsInformacionGeneralEntidadService(): Observable<BodyListResponse<VwsInformacionGeneralEntidadDTO>> {
    return this.http.get<BodyListResponse<VwsInformacionGeneralEntidadDTO>>(API_URL + '/api/v1/vwsInformacionGeneralEntidad/todos');
  }

  guardarVwsInformacionGeneralEntidadService(vwsInformacionGeneralEntidadDTO: VwsInformacionGeneralEntidadDTO): Observable<BodyResponse<VwsInformacionGeneralEntidadDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/vwsInformacionGeneralEntidad', vwsInformacionGeneralEntidadDTO);
  }

  getVwsInformacionGeneralEntidadPorCodigoEntidadBeneficiariaService(codigoEntidadBeneficiaria: string): Observable<BodyResponse<VwsInformacionGeneralEntidadDTO>> {
    return this.http.get<BodyResponse<VwsInformacionGeneralEntidadDTO>>(API_URL + '/api/v1/vwsInformacionGeneralEntidad/' + codigoEntidadBeneficiaria);
  }
}
